<template>
  <div>
    <TitlePage title="Sport Master Config"></TitlePage>

    <v-row class="align-center">
      <v-col cols="12" md="6">
        <v-btn
            elevation="2"
            color="secondary"
            small
            class="mr-2"
            :to="pathCreate"
        >
          <v-icon left>mdi-plus</v-icon>
          Crea configurazione
        </v-btn>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Filtra risultati"
            hide-details
            dense
        />
      </v-col>

      <v-col cols="12">
        <ItemActions :selected="selected" @message="actionHandler"></ItemActions>
      </v-col>
    </v-row>

    <div class="mt-5">
      <v-data-table
          v-model="selected"
          :headers="headers"
          :items="items"
          :single-select="false"
          item-key="_id"
          show-select
          class="elevation-1"
          :search="search"
      >
        <template v-slot:item.active="{ item }">
          <v-switch
              v-model="item.active"
              inset
              hide-details
              dense
              class="mt-0"
              @change="updateSingleActive(item)"
          ></v-switch>
        </template>

        <template v-slot:item.roles_count="{ item }">
          {{ (item.roles || []).length }}
        </template>

        <template v-slot:item.skills_count="{ item }">
          {{ (item.skills || []).length }}
        </template>

        <template v-slot:item.stats_count="{ item }">
          {{ (item.stats || []).length }}
        </template>

        <template v-slot:item.action="{ item }">
          <v-icon
              @click="edit(item._id)"
              title="Modifica"
              color="primary"
          >
            mdi-file-edit
          </v-icon>
          <v-icon
              @click="confirmRemove(item._id)"
              title="Elimina"
              color="primary"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </div>

    <ModalDelete :modalDelete="modalDelete" @message="removeHandler" />
  </div>
</template>

<script>
import TitlePage from '@/components/utils/TitlePage'
import ModalDelete from '@/components/layout/ModalDelete.vue'
import ItemActions from '@/components/layout/ItemActions.vue'
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'SportMasterConfigIndex',
  components: { ItemActions, ModalDelete, TitlePage },
  data () {
    return {
      pathCreate: '/settings/sports-config-master/create/',
      pathEdit: '/settings/sports-config-master/edit/',
      search: '',
      selected: [],
      headers: [
        { text: 'Id', align: 'start', value: '_id' },
        { text: 'Sport master', align: 'start', value: 'sport_master' },
        { text: 'Attivo', value: 'active', sortable: false },
        { text: 'Ruoli', value: 'roles_count', sortable: false },
        { text: 'Skill', value: 'skills_count', sortable: false },
        { text: 'Stats', value: 'stats_count', sortable: false },
        { text: 'Azioni', align: 'start', value: 'action' }
      ],
      items: [],
      ids_to_delete: [],
      modalDelete: false,
      typeDelete: ''
    }
  },
  async created () {
    this.setLoading(true)
    this.items = await this.getItems()
    this.setLoading(false)
  },
  methods: {
    ...mapMutations({
      setLoading: 'settings/setLoading',
      setNotification: 'settings/setNotification'
    }),
    ...mapActions({
      getItems: 'sportMasterConfig/index',
      updateItem: 'sportMasterConfig/update',
      deleteItem: 'sportMasterConfig/delete',
      massiveDeleteItem: 'sportMasterConfig/massDelete'
    }),

    async actionHandler (type) {
      switch (type) {
        case 'edit':
          if (this.selected.length === 1) {
            await this.edit(this.selected[0]._id)
          }
          break
        case 'massiveDelete':
          await this.confirmMassiveRemove()
          break
        default:
          break
      }
    },

    edit (id) {
      this.$router.push(this.pathEdit + id)
    },

    confirmRemove (id) {
      this.ids_to_delete = [id]
      this.modalDelete = true
      this.typeDelete = 'single'
    },

    confirmMassiveRemove () {
      this.ids_to_delete = this.selected.map(x => x._id)
      this.modalDelete = true
      this.typeDelete = 'massive'
    },

    async removeHandler (mode) {
      if (this.typeDelete === 'single') {
        await this.remove(mode)
      } else if (this.typeDelete === 'massive') {
        await this.massiveRemove(mode)
      } else {
        this.modalDelete = false
        this.ids_to_delete = []
        this.typeDelete = ''
      }
    },

    async remove (mode) {
      if (!mode) {
        this.modalDelete = false
        return
      }

      this.modalDelete = false
      this.setLoading(true)

      const result = await this.deleteItem({ id: this.ids_to_delete[0] })

      if (result.success) {
        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: 'Elemento eliminato con successo'
        })

        this.items = await this.getItems()
      } else {
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })
      }

      this.setLoading(false)
    },

    async massiveRemove (mode) {
      if (!mode) {
        this.modalDelete = false
        return
      }

      this.modalDelete = false
      this.setLoading(true)

      const payload = { filter: { _id: { $in: this.ids_to_delete } } }
      const result = await this.massiveDeleteItem(payload)

      if (result.success) {
        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: 'Elementi eliminati con successo'
        })

        this.items = await this.getItems()
        this.selected = []
        this.ids_to_delete = []
      } else {
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })
      }

      this.setLoading(false)
    },

    async updateSingleActive (item) {
      this.setLoading(true)
      const result = await this.updateItem({
        id: item._id,
        item: { active: item.active }
      })
      this.setLoading(false)

      if (result.success) {
        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: 'Aggiornamento completato'
        })
      } else {
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })
      }
    }
  }
}
</script>
